import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "TUIKit-navbar"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "TUIKit-main-container" }
const _hoisted_5 = {
  key: 0,
  class: "TUIKit-main"
}
const _hoisted_6 = {
  key: 1,
  class: "TUIKit-main"
}
const _hoisted_7 = {
  key: 0,
  class: "TUIKit-main-aside"
}
const _hoisted_8 = {
  key: 1,
  class: "TUIKit-main-main"
}
const _hoisted_9 = {
  key: 2,
  class: "TUIKit-main"
}
const _hoisted_10 = {
  key: 3,
  class: "TUIKit-main"
}

import { ref, onMounted, framework } from "./adapter-vue";
import { TUILogin } from "@tencentcloud/tui-core";
import {
  TUIStore,
  StoreName,
  TUIConversationService,
  TUITranslateService,
} from "@tencentcloud/chat-uikit-engine";
import {
  TUISearch,
  TUIConversation,
  TUIChat,
  TUIContact,
  TUIGroup,
} from "./components";
import { isH5 } from "./utils/env";
import PersonCenter from "@/views/PersonCenter/index.vue";
import GroupChat from "@/views/PersonCenter/groupChat/index.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  // When deploying a production environment, you do not need to pass in SDKAppID, userID, and userSig through props.
  // eslint-disable-next-line vue/prop-name-casing
  SDKAppID: {
    type: Number,
    default: 0,
    required: false,
  },
  userID: {
    type: String,
    default: "",
    required: false,
  },
  userSig: {
    type: String,
    default: "",
    required: false,
  },
  conversationID: {
    type: String,
    default: "",
    required: false, // When integrating Chat independently, you need to pass the conversationID
  },
},
  setup(__props) {

const storage = ref(localStorage);
const currentConversationID = ref<string>("");
const currentNavbar = ref<string>("message");
const currentLanguage = ref<string>("zh");
const navbarList = [
  {
    id: "group",
    label: "聊天室",
    icon: require("@/assets/icons/group.svg"),
    activeIcon: require("@/assets/icons/group-ac.svg"),
  },
  {
    id: "message",
    label: "对话",
    icon: require("@/assets/icons/msg.svg"),
    activeIcon: require("@/assets/icons/msg-ac.svg"),
  },
  {
    id: "contact",
    label: "联系人",
    icon: require("@/assets/icons/person.svg"),
    activeIcon: require("@/assets/icons/person-ac.svg"),
  },
  {
    id: "my",
    label: "我的",
    icon: require("@/assets/icons/my.svg"),
    activeIcon: require("@/assets/icons/my-ac.svg"),
  },
];

const props = __props;

onMounted(() => {
  TUIStore.watch(StoreName.CONV, {
    currentConversationID: (id: string) => {
      currentConversationID.value = id;
    },
  });

  // Default login logic
  login();

  // init language by SDKAppID
  initLanguage();

  // Modify CallKit style in H5 environment
  modifyCallKitStyle();

  currentNavbar.value = storage.value.getItem("currentNavbar") || "message";
});

function login() {
  const { SDKAppID, userID, userSig, conversationID } = props;
  if (SDKAppID && userID && userSig) {
    TUILogin.login({
      SDKAppID,
      userID,
      userSig,
      useUploadPlugin: true,
      framework,
    })
      .then(() => {
        // Execute the following code when integrating Chat independently
        if (
          conversationID.startsWith("C2C") ||
          conversationID.startsWith("GROUP")
        ) {
          TUIConversationService.switchConversation(conversationID);
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      })
      .catch((error) => { });
  }
}

function isIntlSDKAppID(SDKAppID: number) {
  if (
    SDKAppID === 0 ||
    (SDKAppID >= 20000000 && SDKAppID < 90000000) ||
    (SDKAppID >= 1720000000 && SDKAppID < 1790000000)
  ) {
    return true;
  }
  return false;
}

function initLanguage() {
  currentLanguage.value = isIntlSDKAppID(props.SDKAppID) ? "en" : "zh";
  TUITranslateService.changeLanguage(currentLanguage.value);
}

function modifyCallKitStyle() {
  if (isH5) {
    const bodyStyle = document.getElementsByTagName("body")[0].style;
    bodyStyle.setProperty("--callLeft", "0");
    bodyStyle.setProperty("--callTop", "0");
    bodyStyle.setProperty("--callWidth", "100%");
    bodyStyle.setProperty("--callHeight", "100%");
  }
}
const onNavBarChange = (id: string) => {
  currentNavbar.value = id;
  storage.value.setItem("currentNavbar", id);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { key: _unref(currentLanguage) }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createElementVNode("div", {
        class: _normalizeClass(['TUIKit', _unref(isH5) && 'TUIKit-h5'])
      }, [
        (!(_unref(isH5) && _unref(currentConversationID)))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navbarList, (item) => {
                return _createElementVNode("div", {
                  key: item.id,
                  class: _normalizeClass(['TUIKit-navbar-item', _unref(currentNavbar) === item.id && 'TUIKit-navbar-item-active']),
                  onClick: ($event: any) => (onNavBarChange(item.id))
                }, [
                  _createElementVNode("img", {
                    class: "TUIKit-navbar-item-icon",
                    src: _unref(currentNavbar) === item.id ? item.activeIcon : item.icon
                  }, null, 8, _hoisted_3),
                  _createElementVNode("span", null, _toDisplayString(_unref(TUITranslateService).t(item.label)), 1)
                ], 10, _hoisted_2)
              }), 64))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          (_unref(currentNavbar) === 'group')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(GroupChat)
              ]))
            : (_unref(currentNavbar) === 'message')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (!(_unref(isH5) && _unref(currentConversationID)))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_unref(TUISearch), { searchType: "global" }),
                        _createVNode(_unref(TUIConversation))
                      ]))
                    : _createCommentVNode("", true),
                  (!_unref(isH5) || _unref(currentConversationID))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_unref(TUIChat), null, {
                          default: _withCtx(() => [
                            _createElementVNode("h1", null, _toDisplayString(_unref(TUITranslateService).t('欢迎使用腾讯云即时通信IM')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(TUIGroup), {
                          class: _normalizeClass(_unref(isH5) ? 'chat-popup' : 'chat-aside')
                        }, null, 8, ["class"]),
                        _createVNode(_unref(TUISearch), {
                          class: _normalizeClass(_unref(isH5) ? 'chat-popup' : 'chat-aside'),
                          searchType: "conversation"
                        }, null, 8, ["class"])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(isH5) && !_unref(currentConversationID))
                    ? (_openBlock(), _createBlock(_unref(TUIGroup), {
                        key: 2,
                        class: "chat-popup"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(TUIContact), { displayType: "selectFriend" })
                ]))
              : (_unref(currentNavbar) === 'contact')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_unref(TUIContact), {
                      displayType: "contactList",
                      onSwitchConversation: _cache[0] || (_cache[0] = ($event: any) => (currentNavbar.value = 'message'))
                    })
                  ]))
                : (_unref(currentNavbar) === 'my')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(PersonCenter)
                    ]))
                  : _createCommentVNode("", true)
        ])
      ], 2)
    ])
  ]))
}
}

})